/* 🤖 this file was generated by svg-to-ts */
export const matIconGite: {
  name: 'gite';
  data: string;
} = {
  name: 'gite',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M18 6H9V4H7v2H6l-4 4v9h20v-9l-4-4zM4 12h10v5H4v-5zm16 5h-4v-6.17l2-2 2 2V17z"/></svg>`
};
